export const leadStatusConstant = {
  // Get lead statuses
  GET_LEAD_STATUSES_R: "GET_LEAD_STATUSES_R",
  GET_LEAD_STATUSES_S: "GET_LEAD_STATUSES_S",
  GET_LEAD_STATUSES_F: "GET_LEAD_STATUSES_F",

  // Create lead status
  CREATE_LEAD_STATUS_R: "CREATE_LEAD_STATUS_R",
  CREATE_LEAD_STATUS_S: "CREATE_LEAD_STATUS_S",
  CREATE_LEAD_STATUS_F: "CREATE_LEAD_STATUS_F",

  // Update lead status
  UPDATE_LEAD_STATUS_R: "UPDATE_LEAD_STATUS_R",
  UPDATE_LEAD_STATUS_S: "UPDATE_LEAD_STATUS_S",
  UPDATE_LEAD_STATUS_F: "UPDATE_LEAD_STATUS_F",

  // Delete lead status
  DELETE_LEAD_STATUS_R: "DELETE_LEAD_STATUS_R",
  DELETE_LEAD_STATUS_S: "DELETE_LEAD_STATUS_S",
  DELETE_LEAD_STATUS_F: "DELETE_LEAD_STATUS_F",
};

